export default __webpack_public_path__ + "static/media/Mechno-Leg-03.8e9c1ef0.jpg";